import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=57564f72&scoped=true"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=57564f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57564f72",
  null
  
)

export default component.exports